import * as React from 'react';
import TilmeldingVaelgKonkurrence from './TilmeldingVaelgKonkurrence';
import TilmeldHoldContainer from './TilmeldHoldContainer';
import { Switch, Route } from 'react-router-dom';
import TilmeldingLogin from './TilmeldingLogin';
import { RouteComponentProps } from 'react-router';
import { PrivateRoute } from '../../infrastructure/PrivateRoute';
import TilmeldingRedigerContainer from './TilmeldingRedigerContainer';
import TilmeldingAccepterInvitation from './TilmeldingAccepterInvitation';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';

export interface TilmeldingFlowContainerProps extends RouteComponentProps<any> {

}

class TilmeldingFlowContainer extends React.Component<TilmeldingFlowContainerProps, any> {
    constructor(props: TilmeldingFlowContainerProps) {
        super(props);
    }

    createTilmeldHoldContainer(props: any, venteliste: boolean) {
        return <TilmeldHoldContainer konkurrenceId={props.match.params.id} venteliste={venteliste} {...this.props} />;
    }

    render() {
        const tilmeldingLogin = () => <TilmeldingLogin {...this.props} />;
        return (
            <PageWrapper>
                <Switch>
                    <PrivateRoute path={'/tilmelding/vaelg-konkurrence'} component={TilmeldingVaelgKonkurrence} location={this.props.location} />
                    <PrivateRoute path={'/tilmelding/rediger/:id'} component={TilmeldingRedigerContainer} location={this.props.location} />
                    <PrivateRoute path={'/tilmelding/tilmeld-hold-venteliste/:id'} component={p => this.createTilmeldHoldContainer(p, true)} location={this.props.location} />
                    <PrivateRoute path={'/tilmelding/tilmeld-hold/:id'} component={p => this.createTilmeldHoldContainer(p, false)} location={this.props.location} />
                    <PrivateRoute path={'/tilmelding/accepter-invitation/:id'} component={TilmeldingAccepterInvitation} location={this.props.location} />
                    <Route render={tilmeldingLogin} location={this.props.location} />
                </Switch>
            </PageWrapper>
        );
    }
}

export default TilmeldingFlowContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/tilmelding/TilmeldingFlowContainer.tsx